import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  userType: string = '';
  entityId = 'ABG';
  userId: string = '';
  userName: string = '';
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor() {
    this.syncCurrentUserState(this.getCurrentUser());
  }

  getToken(): string | null {
    return window.localStorage.getItem('token');
  }

  saveToken(token: string): void {
    window.localStorage.setItem('token', token);
  }
  destroyToken() {
    window.localStorage.removeItem('token');
  }
  getCurrentUser() {
    const getData = window.sessionStorage.getItem('currentUser');

    if (!getData) {
      return null;
    }

    try {
      return JSON.parse(getData);
    } catch {
      return null;
    }
  }
  saveCurrentUser(currentUser: any) {
    const value = JSON.stringify(currentUser)
    window.sessionStorage.setItem('currentUser', value);
    this.syncCurrentUserState(currentUser);
  }
  setCurrentUserFromLogin(user: { userId: string; userType: string; userName: string }): void {
    this.saveCurrentUser(user);
  }
  destroyCurrentUser() {
    window.sessionStorage.removeItem('currentUser');
    this.syncCurrentUserState(null);
  }
  public data: any = null;
  setMenuList(menuList: any) {
    this.data = menuList;
  }
  getMenuList() {
    return this.data;
  }

  private syncCurrentUserState(currentUser: any): void {
    this.userId = currentUser?.userId || currentUser?.wuUserId || currentUser?.id || '';
    this.userName = currentUser?.userName || currentUser?.name || '';
    this.userType = currentUser?.userType || currentUser?.wuUserType || '';
  }

}
